export const taskStates = { waiting: 'Ожидает выполнения', working: 'Выполняется', paused: 'Приостановлена', review: 'На проверке', closed: 'Закрыта' }
export const taskState = item => item.state || (Number(item.status) === 1 ? (Number(item.pause) === 1 ? 'paused' : 'working') : ({ 0: 'waiting', 2: 'review', 3: 'closed' })[item.status] || 'waiting')
export function taskForm(data, files, format = 'bbcode') {
  const form = new FormData()
  Object.entries({ ...data, format }).forEach(([key, value]) => form.append(key, value))
  files.forEach(file => form.append('files[]', file))
  return form
}
